<template src="./dettaglioPrev.html"></template>

<script>
import {
  get_varianti,
  get_progDettaglio,
  get_Misure,
  get_dettaglioPrev,
  set_posizione,
  set_variante,
  del_dettaglioPreventivo,
  get_disegnoDettaglio,
  get_modelli,
} from "@/api/api.preventivi.js";

export default {
  props: {
    dialog: { type: Boolean, default: false },
    prog: { type: Number, default: 0 }, // NOTA: serve anche x capire se sono in modifica
    numPrev: { type: Number, default: 0 },
    //prezzo: { type: Number, default: 0 },
    NoteRigo: { type: String, default: "" },
    Riferimento: { type: String, default: "" },
    azione: { type: String, default: "nuovo" },
    CodCollezione: { type: String, default: "" },
  },

  data: () => ({
    imgDettaglio: {
      modello: "",
      tipoT: "",
      coloreA: "",
      coloreT: "",
      copI: "",
      copE: "",
      alt: "",
      largh: "",
      battente: "",
      scorrevole: "",
      maniglia: "",
    },

    tipoPorta: "battente",
    datiModello: [],
    datiDettaglio: {},
    datiApertura: [],
    datiTipoTelaio: [],
    datiTipoCoprifiloEsterno: [],
    datiTipoCoprifiloInterno: [],
    datiColoreAnta: [],
    datiColoreTelaio: [],
    datiTipoVetro: [],
    datiInterno: [],
    datiForatura: [],
    datiSerratura: [],
    datiMantovana: [],
    datiManiglia: [],
    datiManiglietta: [],
    datiColoreFerr: [],
    datiSpessoreAnta: [],

    stepper: ["Tipologia", "Dettaglio Anta", "Misure", "Ferramenta"],
    step: 1,
    stepMax: 4,

    datiDettaglio_empty: {
      CodModello: "",
      CodApertura: "",
      CodTipoTelaio: "",
      CodColoreAnta: "",
      CodColoreTelaio: "",
      CodTipoCoprifiloEsterno: "",
      CodTipoCoprifiloInterno: "",
      CodTipoVetro: "",
      CodTipoSerratura: "",
      CodTipoInterno: "Nido d'ape",
      CodTipoForatura: "",
      CodTipoMantovana: "",
      CodTipoManiglia: "",
      CodTipoManiglietta: "",
      CodColoreFerr: "",
      CodSpessoreAnta: "",
      Scheda: 0,
      CodProgetto: "",
      riferimento: "",
      Qta: 1,
      H: 2100,
      L: 600,
      S: 80,
      QtaAnube: 1,
      noteRigo: "",

      Importo: "-",
    },

    pagination: {
      sortBy: "ProgVariante",
    },

    progVariante: 0,

    //pathImg: "", //inserimento icona elemento
    progDett: 0,
    posVariante: 0, //valori posizione e id: posVariante[0] -> posizione, posVariante[1] -> id

    caricaGrigliaDett: false,
    attesa: false,

    textRules: [(v) => !!v || "Il campo è obbligatorio"],
    numericRules: [
      (v) => !!v || "Obbligatorio",
      (v) => v != 0 || "Obbligatorio",
    ],

    datiLarghezze: [],
    datiSpessore: [],

    allValues: true,
  }),

  methods: {
    /**  carica dati  **/
    async caricaDati() {
      if (!this.dialog) return;
      this.imgDettaglio = {};
      this.datiDettaglio = Object.assign({}, this.datiDettaglio_empty);
      if (!isNaN(this.prog) && this.prog >= 1 && this.azione == "modifica") {
        //sono in modifica
        this.caricaVariantiModifica();
        this.caricaValoriModifica();
      } else if (
        !isNaN(this.prog) &&
        this.prog >= 1 &&
        this.azione == "duplica"
      ) {
        this.caricaVariantiModifica();
        this.caricaValoriModifica();
        this.caricaProgDettaglio();
      }

      this.allValues = true;
      this.progVariante = 0;
      this.datiApertura = [];
      this.progDett = this.prog;
      this.step = 1;
      //this.$refs.formDettaglio.reset();
      this.$nextTick(() => this.$refs.formDettaglio.resetValidation());

      this.imgDettaglio.battente = this.getImg("aperture", "battente" + ".jpg");
      this.imgDettaglio.scorrevole = this.getImg(
        "aperture",
        "scorrevole" + ".jpg"
      );
      this.imgDettaglio.alt = this.getImg("misure", "Altezza.png");
      this.imgDettaglio.largh = this.getImg("misure", "Larghezza.png");
    },

    fineCaricamentoOrdine() {
      // Fine attesa
      setTimeout(() => {
        this.$root.$wait.close();
      }, 300);
    },

    async caricaVariantiModifica() {
      this.imgDettaglio = {};
      await this.caricaVarianti("ColoreAnta"); //colore anta
      await this.caricaVarianti("ColoreTelaio"); //colore telaio
      await this.caricaVarianti("Apertura"); //apertura
      await this.caricaVarianti("TipoTelaio"); //tipo telaio
      await this.caricaVarianti("ColoreFerramenta"); //colore ferramenta
      await this.caricaMisure("larghezza");
      await this.caricaMisure("spessore");
      await this.caricaVarianti("Maniglia"); //maniglia
      await this.caricaVarianti("TipoCoprifilo"); //tipo coprifilo
    },

    //carica tutti i valori relativi alla riga del preventivo da modificare
    async caricaValoriModifica() {
      let res = await get_dettaglioPrev(this.numPrev, this.prog);
      if (res.data == null) return;
      this.pulisciCampi();
      this.datiDettaglio.CodModello = res.data.Modello;
      this.datiDettaglio.CodApertura = res.data.Apertura;
      this.datiDettaglio.CodTipoTelaio = res.data.TipoTelaio;
      this.datiDettaglio.CodColoreAnta = res.data.ColoreAnta;
      this.datiDettaglio.CodColoreTelaio = res.data.ColoreTelaio;
      this.datiDettaglio.CodTipoCoprifiloEsterno = res.data.CopEsterno;
      this.datiDettaglio.CodTipoCoprifiloInterno = res.data.CopInterno;
      this.datiDettaglio.CodTipoSerratura = res.data.Serratura;
      this.datiDettaglio.CodTipoMantovana = res.data.Mantovana;
      this.datiDettaglio.CodTipoManiglia = res.data.Maniglia;
      this.datiDettaglio.CodColoreFerr = res.data.ColoreFerramenta;
      this.datiDettaglio.Qta = res.data.Quantita;
      this.datiDettaglio.H = parseInt(res.data.H);
      this.datiDettaglio.L = parseInt(res.data.L);
      this.datiDettaglio.S = parseInt(res.data.S);
      this.datiDettaglio.noteRigo = this.NoteRigo;
      this.datiDettaglio.riferimento = this.Riferimento;
      if (this.datiDettaglio.CodApertura.substring(0, 10) == "Scorrevole")
        this.tipoPorta = "scorrevole";
      else this.tipoPorta = "battente";

      //????? l'immagine del modello la devo caricare 2 volte altrimenti non la prende ?????
      //this.caricaImg("modello", this.datiDettaglio.CodModello);
      this.caricaImg("Altezza", "");
      this.caricaImg("Larghezza", "");
      this.imgDettaglio.battente = this.getImg("aperture", "battente.jpg");
      this.imgDettaglio.scorrevole = this.getImg("aperture", "scorrevole.jpg");
      this.caricaImgMisure(this.tipoPorta);
      if (this.datiDettaglio.CodModello == "UNO") {
        this.imgDettaglio.alt = this.getImg("misure", "Altezza_Rasomuro.png");
        this.imgDettaglio.largh = this.getImg(
          "misure",
          "Larghezza_Rasomuro.png"
        );
      }
    },

    pulisciCampi() {
      this.datiLarghezze = [];
      this.datiSpessore = [];
      this.datiDettaglio.CodModello = "";
      this.datiDettaglio.CodApertura = "";
      this.datiDettaglio.CodTipoTelaio = "";
      this.datiDettaglio.CodColoreAnta = "";
      this.datiDettaglio.CodColoreTelaio = "";
      this.datiDettaglio.CodTipoCoprifiloEsterno = "";
      this.datiDettaglio.CodTipoCoprifiloInterno = "";
      this.datiDettaglio.CodTipoSerratura = "";
      this.datiDettaglio.CodTipoManiglia = "";
      this.datiDettaglio.CodTipoManiglietta = "";
      this.datiDettaglio.CodColoreFerr = "";
      this.datiDettaglio.riferimento = "";
      this.datiDettaglio.Qta = 1;
      this.datiDettaglio.H = 2100;
      this.datiDettaglio.L = 60;
      this.datiDettaglio.S = 8;
      this.datiDettaglio.QtaAnube = 1;
      this.datiDettaglio.noteRigo = ""; //note inserite in set_posizione, stored uspweb_INS_PRE_Dettaglio
      this.imgDettaglio = {};
      this.datiDettaglio = Object.assign({}, this.datiDettaglio_empty);
    },

    chiudi() {
      this.$emit("caricaDati", this.numPrev);
      this.$emit("chiudiDialog", true);
      // Reset
      this.caricaGrigliaDett = false;
    },

    async nextStep() {
      if (this.controllaValoriInseriti(this.step)) {
        if (this.step == 1) {
          // ----------------
          // Primo step
          // ----------------

          /**
           * 0     -->  aggiunge
           * altro -->  update
           */
          let stringaDati = {
            id: this.numPrev,
            pos: this.progDett,
            modello: this.datiDettaglio.CodModello,
            mantovana: "",
            maniglia: "",
            maniglietta: "",
            quantita: this.datiDettaglio.Qta,
            H: this.datiDettaglio.H,
            L: this.datiDettaglio.L,
            S: this.datiDettaglio.S,
            ColoreAnta: this.datiDettaglio.CodColoreAnta,
            tipoTelaio: this.datiDettaglio.CodTipoTelaio,
            ColoreTelaio: this.datiDettaglio.CodColoreTelaio,
            riferimento: this.datiDettaglio.riferimento,
            noteRigo: this.datiDettaglio.noteRigo,
          };

          let res = await set_posizione(stringaDati);
          if (res.data.isNull || res.data == "NO") this.$toast.error("errore!");
          //se seleziono lo scorrevole devo togliere il modello UNO Rasomuro
          res = null;
          res = await get_modelli(this.CodCollezione);
          this.datiModello = res.data;
          if (this.tipoPorta == "scorrevole") {
            for (let i = 0; i < this.datiModello.length; i++) {
              if (this.datiModello[i].modello == "UNO")
                this.datiModello.splice(i, 1);
            }
          }
        } else if (this.step == 2) {
          // ----------------
          // Secondo step
          // ----------------

          let stringaDati = {
            id: this.numPrev,
            pos: this.progDett,
            modello: this.datiDettaglio.CodModello,
            mantovana: this.datiDettaglio.CodTipoMantovana,
            maniglia: "",
            maniglietta: "",
            quantita: this.datiDettaglio.Qta,
            H: this.datiDettaglio.H,
            L: this.datiDettaglio.L,
            S: this.datiDettaglio.S,
            ColoreAnta: this.datiDettaglio.CodColoreAnta,
            tipoTelaio: this.datiDettaglio.CodTipoTelaio,
            ColoreTelaio: this.datiDettaglio.CodColoreTelaio,
            riferimento: this.datiDettaglio.riferimento,
            noteRigo: this.datiDettaglio.noteRigo,
          };
          let res = await set_posizione(stringaDati);
          if (res.data.isNull) this.$toast.error("errore!");
          else if (res.data == "NO") this.$toast.error("errore!");

          await this.caricaMisure("larghezza");
          await this.caricaMisure("spessore");
        } else if (this.step == 3) {
          // ----------------
          // Terzo step
          // ----------------

          let stringaDati = {
            id: this.numPrev,
            pos: this.progDett,
            modello: this.datiDettaglio.CodModello,
            mantovana: this.datiDettaglio.CodTipoMantovana,
            maniglia: "",
            maniglietta: "",
            quantita: this.datiDettaglio.Qta,
            H: this.datiDettaglio.H,
            L: this.datiDettaglio.L,
            S: this.datiDettaglio.S,
            ColoreAnta: this.datiDettaglio.CodColoreAnta,
            tipoTelaio: this.datiDettaglio.CodTipoTelaio,
            ColoreTelaio: this.datiDettaglio.CodColoreTelaio,
            riferimento: this.datiDettaglio.riferimento,
            noteRigo: this.datiDettaglio.noteRigo,
          };
          let res = await set_posizione(stringaDati);
          if (res.data.isNull) this.$toast.error("errore!");
          else if (res.data == "NO") this.$toast.error("errore!");
        } else if (this.step == this.stepMax) {
          // ----------------
          // Ultimo step
          // ----------------

          await this.setVariante(
            "Serratura",
            this.datiDettaglio.CodTipoSerratura
          );
          //maniglia/maniglietta
          //colore ferramenta
          //numero anube

          this.salva(true);
          //inserire rigo nella tabella dei preventivi
          return;
        }
        this.step++; //aggiungere controllo su speedy
      }
    },

    prevStep() {
      this.step--; //aggiungere controllo su speedy
    },

    async caricaMisure(valore) {
      let res = await get_Misure(valore, this.numPrev, this.progDett);
      if (valore == "larghezza")
        this.datiLarghezze = res.data.map(function (item) {
          return item["Variante"];
        });
      else if (valore == "spessore")
        this.datiSpessore = res.data.map(function (item) {
          return item["Variante"];
        });
    },

    //controllo se l'utente inserisce tutti i campi
    controllaValoriInseriti(step) {
      switch (step) {
        case 1:
          this.allValues = true;
          return true;
        case 2:
          if (
            this.datiDettaglio.CodModello != "" &&
            this.datiDettaglio.CodColoreAnta != "" &&
            this.datiDettaglio.CodColoreTelaio != "" &&
            this.datiDettaglio.CodApertura != "" &&
            this.datiDettaglio.CodTipoTelaio != "" &&
            this.datiDettaglio.CodTipoCoprifiloEsterno != "" &&
            this.datiDettaglio.CodTipoCoprifiloInterno != "" &&
            this.datiDettaglio.CodModello != null &&
            this.datiDettaglio.CodColoreAnta != null &&
            this.datiDettaglio.CodColoreTelaio != null &&
            this.datiDettaglio.CodApertura != null &&
            this.datiDettaglio.CodTipoTelaio != null &&
            this.datiDettaglio.CodTipoCoprifiloEsterno != null &&
            this.datiDettaglio.CodTipoCoprifiloInterno != null
          ) {
            this.allValues = true;
            return true;
          }
          this.allValues = false;
          return false;
        case 3:
          if (
            this.datiDettaglio.L > 0 &&
            this.datiDettaglio.H > 0 &&
            this.datiDettaglio.S > 0 &&
            this.datiDettaglio.Qta > 0
          ) {
            this.allValues = true;
            return true;
          }
          this.allValues = false;
          return false;
        case 4:
          if (
            this.datiDettaglio.CodTipoSerratura != "" &&
            this.datiDettaglio.CodColoreFerr != null &&
            this.datiDettaglio.CodColoreFerr != "" &&
            this.datiDettaglio.CodColoreFerr != null &&
            this.datiDettaglio.CodTipoManiglia != "" &&
            this.datiDettaglio.CodColoreFerr != null
          ) {
            this.allValues = true;
            return true;
          }
          this.allValues = false;
          return false;
      }
    },

    ResetValori(cod) {
      switch (cod) {
        case ("ColoreAnta", "ColoreTelaio"):
          this.datiDettaglio.CodTipoTelaio = "";
          this.datiDettaglio.CodTipoCoprifiloEsterno = "";
          this.datiDettaglio.CodTipoCoprifiloInterno = "";
      }
    },

    //inserisce la variante PRE_varianti
    async setVariante(codice, val) {
      this.ResetValori(codice);
      let datiVariante = {
        id: this.numPrev,
        posizione: this.progDett,
        cod_var: codice,
        valore: val,
      };
      let res = await set_variante(datiVariante);
      if (res.data.isNull || res.data.isNaN) this.$toast.error("errore!");
      else if (res.data == "NO") this.$toast.error("errore!");
    },

    async caricaImg(codice, valore) {
      if (this.$i2kFunctions.isSmartphone()) return;
      if (codice == "" || codice == null || valore == "" || valore == null)
        return;
      let path = "";
      let name = "";
      if (valore == "" || valore == "NO") return;
      if (
        codice != "Altezza" &&
        codice != "Larghezza" &&
        codice != "Maniglia"
      ) {
        let param = {
          modello: this.datiDettaglio.CodModello,
          variante: valore,
        };
        let res = await get_disegnoDettaglio(codice, param);
        name = res.data;
      }
      if (codice == "Maniglia") name = valore + ".png";

      switch (codice) {
        case "Modello":
          path = await this.getImg("dettaglio", name);
          this.imgDettaglio.modello = path;
          break;

        case "ColoreAnta":
          path = await this.getImg("colori", name);
          this.imgDettaglio.coloreA = path;
          break;

        case "ColoreTelaio":
          path = await this.getImg("colori", name);
          this.imgDettaglio.coloreT = path;
          break;

        case "TipoTelaio":
          if (this.tipoPorta == "scorrevole") name = "Scorrevole.png";
          path = await this.getImg("dettaglio", name);
          this.imgDettaglio.tipoT = path;
          break;

        case "CopInterno":
          path = await this.getImg("dettaglio", name);
          this.imgDettaglio.copI = path;
          break;

        case "CopEsterno":
          path = await this.getImg("dettaglio", name);
          this.imgDettaglio.copE = path;
          break;

        case "Maniglia":
          if (this.datiDettaglio.CodTipoManiglia == "Maniglietta Quadra")
            path = await this.getImg(
              "maniglia",
              this.datiDettaglio.CodTipoManiglia + ".png"
            );
          else path = await this.getImg("maniglia", name);

          this.imgDettaglio.maniglia = path;
          break;
      }
    },

    getImg(type, img) {
      if (this.$i2kFunctions.isSmartphone()) return;
      if (img == "" || type == "") return;
      return this.$load.getUrlImg() + "/preventivi/" + type + "/" + img;
    },

    salva(chiudiFinestra, stepAvanti) {
      this.$root.$wait.open();
      if (chiudiFinestra) this.chiudi();
      if (stepAvanti) this.nextStep();
      this.caricaGrigliaDett = true;
    },

    async caricaVarianti(tipoVar) {
      if (this.azione == "modifica" || this.azione == "duplica")
        this.progDett = this.prog;
      let res = {};
      switch (tipoVar) {
        case "ColoreAnta": //Tinta Anta
          this.datiColoreAnta = [];
          res = await get_varianti("ColoreAnta", this.numPrev, this.progDett);
          this.datiColoreAnta = res.data;
          break;
        case "ColoreFerramenta": //Tipo_Fer
          this.datiColoreFerr = [];
          res = await get_varianti(tipoVar, this.numPrev, this.progDett);
          this.datiColoreFerr = res.data;
          break;
        case "Maniglia": //Maniglia
          this.datiManiglia = [];
          res = await get_varianti(tipoVar, this.numPrev, this.progDett);
          this.datiManiglia = res.data;
          break;
        case "Apertura": //Apertura
          this.datiApertura = [];
          res = await get_varianti(tipoVar, this.numPrev, this.progDett);
          this.datiApertura = res.data;
          this.filtraTipoPorta();
          await this.caricaVarianti("Serratura"); //serratura
          break;
        case "Serratura": //Serratura
          this.datiSerratura = [];
          res = await get_varianti(tipoVar, this.numPrev, this.progDett);
          this.datiSerratura = res.data;
          break;
        case "ColoreTelaio": //Tinta Telaio
          this.datiColoreTelaio = [];
          res = await get_varianti("ColoreTelaio", this.numPrev, this.progDett);
          this.datiColoreTelaio = res.data;
          break;
        case "TipoTelaio": //Tipo_Tel
          this.datiTipoTelaio = [];
          res = await get_varianti(tipoVar, this.numPrev, this.progDett);
          this.datiTipoTelaio = res.data;
          break;
        case "TipoCoprifilo": //Tipo coprifilo, lo uso per caricare i coprifili interno/esterno
          this.datiTipoCoprifiloEsterno = [];
          this.datiTipoCoprifiloInterno = [];
          res = await get_varianti("CopEsterno", this.numPrev, this.progDett);
          this.datiTipoCoprifiloEsterno = res.data;

          res = await get_varianti("CopInterno", this.numPrev, this.progDett);
          this.datiTipoCoprifiloInterno = res.data;
          break;
        case "Mantovana":
          res = await get_varianti(tipoVar, this.numPrev, this.progDett);
          this.datiMantovana = res.data;
          break;
      }
    },

    filtraTipoPorta() {
      if (this.datiApertura.length < 4) return;
      if (this.tipoPorta == "battente")
        this.datiApertura = [this.datiApertura[0], this.datiApertura[1]];
      else this.datiApertura = [this.datiApertura[2], this.datiApertura[3]];
    },

    async modificaModello() {
      let stringaDati = {
        id: this.numPrev,
        pos: this.progDett,
        modello: this.datiDettaglio.CodModello,
        mantovana: "",
        maniglia: "",
        maniglietta: "",
        quantita: 1,
        H: 2100,
        L: 0,
        S: 0,
        ColoreAnta: "",
        tipoTelaio: "",
        ColoreTelaio: "",
        tipoCoprifilo: "",
        riferimento: "",
        noteRigo: "",
      };
      //reset dei valori perche cambiando modello cambiano anche gli altri valori
      this.datiDettaglio.CodColoreAnta = "";
      this.datiDettaglio.CodColoreTelaio = "";
      this.datiDettaglio.CodTipoTelaio = "";
      this.datiDettaglio.CodTipoCoprifiloEsterno = "";
      this.datiDettaglio.CodTipoCoprifiloInterno = "";
      this.datiDettaglio.CodTipoSerratura = "";
      this.datiDettaglio.CodColoreFerr = "";
      this.datiDettaglio.CodTipoManiglia = "";
      this.datiDettaglio.L = 0;
      this.datiDettaglio.S = 0;

      this.setVariante("ColoreAnta", "");
      this.setVariante("ColoreTelaio", "");
      this.setVariante("TipoTelaio", "");
      this.setVariante("CopEsterno", "");
      this.setVariante("CopInterno", "");
      this.setVariante("Serratura", "");
      this.setVariante("ColoreFerramenta", "");
      this.setVariante("Maniglia", "");

      let res = await set_posizione(stringaDati);
      if (res.data.isNull) this.$toast.error("errore!");
      else if (res.data == "NO") this.$toast.error("errore!");

      await this.caricaVarianti("ColoreAnta");
      await this.caricaVarianti("ColoreTelaio");
      await this.caricaVarianti("TipoTelaio");
      if (this.datiDettaglio.CodModello == "UNO") {
        this.imgDettaglio.alt = this.getImg("misure", "Altezza_Rasomuro.png");
        this.imgDettaglio.largh = this.getImg(
          "misure",
          "Larghezza_Rasomuro.png"
        );
      } else {
        this.caricaImgMisure(this.tipoPorta);
      }
    },

    async caricaProgDettaglio() {
      if (this.numPrev <= 0) return;
      let res = await get_progDettaglio(this.numPrev);
      this.progDett = res.data;
    },

    //annulla e cancella il rigo di dettaglio
    async Annulla() {
      if (!isNaN(this.prog) && this.prog >= 1) {
        //se in modifica non compila tutti i campi non puo' uscire
        if (
          !(
            this.controllaValoriInseriti(1) &&
            this.controllaValoriInseriti(2) &&
            this.controllaValoriInseriti(3) &&
            this.controllaValoriInseriti(4)
          )
        ) {
          this.$toast.error("Attenzione! Compila tutti i campi e riprova!");
        } else {
          this.chiudi();
        }
        return;
      }
      if (this.step != 1) {
        let confirm = await this.$root.$confirm(
          "Annulla",
          "Vuoi annullare? Tutte le modifiche saranno cancellate."
        );
        if (!confirm) return;
      }
      this.EliminaDettaglio();
    },

    async EliminaDettaglio() {
      let res = await del_dettaglioPreventivo(this.numPrev, this.progDett);
      if (res.data != "OK") {
        this.$toast.error("Impossibile eliminare il dettaglio!");
      } else {
        this.$toast.warning("Dettaglio eliminato!");
        this.chiudi();
      }
    },

    selezionaPorta(tipo) {
      if (tipo != this.tipoPorta) {
        if (this.azione == "modifica" || this.datiDettaglio.CodModello != "") {
          this.$toast.warning(
            "Per selezionare una tipologia diversa creare una nuova posizione"
          );
          return;
        }
        this.datiDettaglio.CodApertura = "";
        this.datiDettaglio.CodTipoTelaio = "";
        this.datiDettaglio.CodTipoCoprifiloEsterno = "";
        this.datiDettaglio.CodTipoCoprifiloInterno = "";
      }
      this.tipoPorta = tipo;
      this.caricaVarianti("Apertura");
      this.caricaImgMisure(tipo);
    },

    caricaImgMisure(tipo) {
      if (tipo == "battente") {
        this.imgDettaglio.alt = this.getImg("misure", "Altezza.png");
        this.imgDettaglio.largh = this.getImg("misure", "Larghezza.png");
      } else if (tipo == "scorrevole") {
        this.imgDettaglio.alt = this.getImg("misure", "Altezza_Scorrevole.png");
        this.imgDettaglio.largh = this.getImg(
          "misure",
          "Larghezza_Scorrevole.png"
        );
      }
    },
  },

  mounted() {
    this.caricaDati();
    this.caricaProgDettaglio();
  },

  watch: {
    dialog(val) {
      this.caricaProgDettaglio();
      return !val || this.caricaDati();
    },

    "datiDettaglio.CodModello": function (newVal, oldVal) {
      this.caricaImg("Modello", newVal);
      //this.caricaVarianti("Modello");
    },

    "datiDettaglio.CodTipoTelaio": function (newVal, oldVal) {
      this.caricaImg("TipoTelaio", newVal);
    },

    "datiDettaglio.CodColoreAnta": function (newVal, oldVal) {
      this.caricaImg("ColoreAnta", newVal);
      this.caricaVarianti("ColoreAnta");
      if (
        newVal == "Cocco" &&
        oldVal == "" &&
        this.datiDettaglio.CodModello == "110" &&
        this.datiDettaglio.CodColoreTelaio == ""
      ) {
        this.datiDettaglio.CodColoreTelaio = "Bianco";
        this.setVariante("ColoreTelaio", this.datiDettaglio.CodColoreTelaio);
      }
    },

    "datiDettaglio.CodColoreTelaio": function (newVal, oldVal) {
      this.caricaImg("ColoreTelaio", newVal);
      this.caricaVarianti("ColoreTelaio");
    },

    "datiDettaglio.CodTipoCoprifiloEsterno": function (newVal, oldVal) {
      if (newVal == "NO") this.imgDettaglio.copE = "";
      this.caricaImg("CopEsterno", newVal);
      this.caricaVarianti("TipoCoprifilo");
    },

    "datiDettaglio.CodTipoCoprifiloInterno": function (newVal, oldVal) {
      if (newVal == "NO") this.imgDettaglio.copI = "";
      this.caricaImg("CopInterno", newVal);
      this.caricaVarianti("TipoCoprifilo");
    },

    "datiDettaglio.CodTipoManiglia": function (newVal, oldVal) {
      if (
        newVal == undefined ||
        newVal == "NO" ||
        newVal == "" ||
        this.datiDettaglio.CodColoreFerr == undefined ||
        this.datiDettaglio.CodColoreFerr == "NO" ||
        this.datiDettaglio.CodColoreFerr == ""
      ) {
        this.imgDettaglio.maniglia = "";
        return;
      }
      this.caricaImg(
        "Maniglia",
        newVal + "" + this.datiDettaglio.CodColoreFerr
      );
      this.caricaVarianti("Maniglia");
    },

    "datiDettaglio.CodColoreFerr": function (newVal, oldVal) {
      if (
        newVal == undefined ||
        newVal == "NO" ||
        newVal == "" ||
        this.datiDettaglio.CodTipoManiglia == undefined ||
        this.datiDettaglio.CodTipoManiglia == "NO" ||
        this.datiDettaglio.CodTipoManiglia == ""
      ) {
        this.imgDettaglio.maniglia = "";
        return;
      }
      this.caricaImg(
        "Maniglia",
        this.datiDettaglio.CodTipoManiglia + "" + newVal
      );
      this.caricaVarianti("ColoreFerramenta");
    },
  },
};
</script>


<style scoped src="../../../assets/styles/preventivo.css"></style>